import React, { useState, useEffect } from 'react';
import styles from './ShareFolderModal.module.scss';
import Modal from '../Modal';
import { useTranslation } from 'react-i18next';
import { Icon } from '../Icon';
import ShareModalContent from './ShareModalContent/ShareModalContent';
import ShareFolderNotification from './ShareFolderNotification/ShareFolderNotification';
import CloseButton from '../CloseButton/CloseButton';

const ShareFolderModal = props => {
  const {
    isRedirect,
    sharedFolderWithUsers,
    editFolderUsers,
    deleteFolderUsers,
    changeFolderEditingRight,
    onClose,
    isShow,
    folder,
    usersOutsideCompany,
  } = props;

  /*
    Content Type is needed to display the desired list of users.
    If the user opened a modal window and didn't add anyone,
    he will only see a list of existing users in this folder.
    As soon as a user adds a new email via the input field,
    a list of new users will be displayed instead of a list of existing ones.
    Two content types is available: 
    1 - existingUsers;
    2 - newUsers;
  */
  const [contentType, setContentType] = useState(1);

  const { t } = useTranslation();
  const [notificationMode, setNotificationMode] = useState(false);
  const [newUsers, setNewUsers] = useState([]);
  const [unvalidEmails, setUnvalidEmails] = useState([]);

  useEffect(() => {
    if (usersOutsideCompany.length > 0) {
      setNotificationMode(true);
    }
    return () => {
      setNotificationMode(false); // This worked for me
    };
  }, [usersOutsideCompany]);

  return (
    <Modal className={styles.modal} open={isShow} onClose={onClose}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <div className={styles.headerContainer}>
            {notificationMode ? <span className={styles.modalTitle}>{t('general.share')}?</span> : <>
              {contentType === 1 ? (
              <span className={styles.modalTitle}>
                {t('share_folder_modal.first_step.title')} "{folder?.name}"
              </span>
              ) : contentType === 2 ? (
              <>
                <Icon
                  src="arrowLeft"
                  className={styles.arrowLeftIcon}
                  onClick={() => {
                    setNewUsers([]);
                    setUnvalidEmails([]);
                  }}
                />
                <span className={styles.modalTitle}>
                  {t('share_folder_modal.second_step.title')} "{folder?.name}"
                </span>
              </>
              ) : null}
            </>}
          </div>
          <CloseButton onClose={onClose} className={styles.closeBtn} />
        </div>
      </div>
      {notificationMode ? (
        <ShareFolderNotification rejectedFolders={usersOutsideCompany} onClose={onClose} />
      ) : (
        <ShareModalContent
          isRedirect={isRedirect}
          contentType={contentType}
          setContentType={setContentType}
          folder={folder}
          onClose={onClose}
          sharedFolderWithUsers={sharedFolderWithUsers}
          editFolderUsers={editFolderUsers}
          deleteFolderUsers={deleteFolderUsers}
          changeFolderEditingRight={changeFolderEditingRight}
          newUsers={newUsers}
          setNewUsers={setNewUsers}
          unvalidEmails={unvalidEmails}
          setUnvalidEmails={setUnvalidEmails}
        />
      )}
    </Modal>
  );
};

export default ShareFolderModal;
